/**
 * @generated SignedSource<<0ac0fa38af40dfc4aa77d89df70b4c34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResult_AtlassianSearchPage$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultRenderer_AtlassianSearchPage">;
  readonly " $fragmentType": "searchResult_AtlassianSearchPage";
};
export type searchResult_AtlassianSearchPage$key = {
  readonly " $data"?: searchResult_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResult_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssets"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssigneeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    }
  ],
  "kind": "Fragment",
  "name": "searchResult_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeAssets",
          "variableName": "includeAssets"
        },
        {
          "kind": "Variable",
          "name": "includeAssigneeField",
          "variableName": "includeAssigneeField"
        },
        {
          "kind": "Variable",
          "name": "includeIconUrl",
          "variableName": "includeIconUrl"
        },
        {
          "kind": "Variable",
          "name": "includeNavBoostScore",
          "variableName": "includeNavBoostScore"
        },
        {
          "kind": "Variable",
          "name": "includePassionfruitAsk",
          "variableName": "includePassionfruitAsk"
        },
        {
          "kind": "Variable",
          "name": "includePositions",
          "variableName": "includePositions"
        },
        {
          "kind": "Variable",
          "name": "includeThirdPartyId",
          "variableName": "includeThirdPartyId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchResultRenderer_AtlassianSearchPage"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};

(node as any).hash = "357a9a65a9ef836dbd146b53259e9fd2";

export default node;
